import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { SidebarClose, SidebarOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSidebar } from "@/components/ui/sidebar";
import { useI18n } from "@/contexts/I18nContext";

export function SidebarOpenButton(props) {
  const { state, toggleSidebar } = useSidebar();
  const { t } = useI18n();
  const isCollapsed = state === "collapsed";
  const label = isCollapsed
    ? t("menu.expand", "메뉴 펼치기")
    : t("menu.collapse", "메뉴 숨기기");

  return (
    <div className="flex items-center justify-center">
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            {...props}
            onClick={toggleSidebar}
            aria-label={label}
            title={label}
          >
            {!isCollapsed ? (
              <SidebarClose className="h-6 w-6" />
            ) : (
              <SidebarOpen className="h-6 w-6" />
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{label}</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
